import React from 'react';

import Brands from 'brandComponents/Brands';

import {EBrandsSectionTypes, IBrandsContentfulProps} from './IBrandsContentful';

const BrandsContentful = (props: IBrandsContentfulProps) => {
	return (
		<Brands
			title={props.title}
			data={props?.itemsCollection?.items}
			type={EBrandsSectionTypes[props.type] || EBrandsSectionTypes['Alphabetic Scroll']}
		/>
	);
};

export default BrandsContentful;
